export default class SupplierPrice {
  constructor (data) {
    // data is an object like:
    // {
    //   commission: "24.00"
    //   currency: "GBP"
    //   description: "Spa Package"
    //   price: "125.00"
    //   quantity: 2
    //   supplier_name: "Whittlebury Hall (Whittlebury Park)"
    //   total: "250.00"
    // }

    Object.assign(this, data)
  }

  get vatRate () {
    return 1.2
  }

  get vatPercentage () {
    return ((this.vatRate - 1) * 100).toFixed(2)
  }

  get netCommissionPercentage () {
    return (parseFloat(this.commission) / this.vatRate).toFixed(2)
  }

  get totalDeduction () {
    return ((parseFloat(this.commission) / 100) * parseFloat(this.total)).toFixed(2)
  }

  get vatValue () {
    return (parseFloat(this.totalDeduction) - parseFloat(this.commissionValue)).toFixed(2)
  }

  get commissionValue () {
    return (parseFloat(this.totalDeduction) / this.vatRate).toFixed(2)
  }
}
